import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background-image":"url('https://images.empoweredconsumerism-static-files.com/ovi/website/images/landing_logo.png')","-webkit-background-size":"cover","-moz-background-size":"cover","-o-background-size":"cover","background-size":"cover"}
}
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "mb-12"
}, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Logo",
    src: "media/ovi.webp",
    class: "h-175px"
  })
], -1)
const _hoisted_4 = {
  id: "app",
  method: "post",
  ref: "ecopenform"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-center flex-column-auto p-10" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("form", _hoisted_4, [
        _withDirectives(_createVNode("input", {
          ref: "username",
          type: "hidden",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.username = $event)),
          name: "username"
        }, null, 512), [
          [_vModelText, _ctx.username]
        ]),
        _withDirectives(_createVNode("input", {
          ref: "password",
          type: "hidden",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
          name: "password"
        }, null, 512), [
          [_vModelText, _ctx.password]
        ])
      ], 512)
    ]),
    _hoisted_5
  ]))
}